export const lockVisibleHeaders = (card, headers) => {
  let headersIndex = 0
  card.sections.forEach(sec => {
    if (sec.type === 'Separator') {
      if (!headers || headersIndex < headers) {
        sec.isLocked = true
      }
      headersIndex++
    }
  })
}

export const saveDispatcher = {
  saveCallback: () => {},
}

export const loadDispatcher = {
  loadCallback: undefined,
}

export function isDarkTheme() {
  const urlParams = new URLSearchParams(window.location.search)
  const theme = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'theme'))
  return theme === 'dark' || (!theme && window.matchMedia('(prefers-color-scheme: dark)').matches)
}

export async function applyCssToShadow(shadowRoot, cssUrl) {
  if (!isValidUrl(cssUrl)) {
    return
  }
  const response = await fetch(cssUrl)
  const cssText = await response.text()

  const style = document.createElement('style')
  style.textContent = cssText

  shadowRoot.appendChild(style)
}

export function isValidUrl(href) {
  try {
    new URL(href)
    return true
  } catch (_) {
    return false
  }
}
